import { StyleSheet } from 'react-native';
import { createTheme } from './theme';
export function createStyleSheet(getStyles) {
    const light = StyleSheet.create(getStyles(createTheme('light')));
    const dark = StyleSheet.create(getStyles(createTheme('dark')));
    return {
        light,
        dark
    };
}
//# sourceMappingURL=style.js.map